module.exports = __webpack_public_path__ + "static/img/group20.424c3eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group20.jpg
// module id = xJFB
// module chunks = 0